import React, { useState } from 'react';
import BaseDirectories from '../../base directories/BaseDiectories';
import { Link } from 'react-router-dom';
import Button from '../../components/ui/Button';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const UserLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const handleSubmit = (e: any) => {
    e.preventDefault();
    console.log({ email, password, rememberMe });
  };
  // Toggle between showing and hiding password
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="max-h-screen bg-gradient-to-r from-[#2D517B] to-[#49C7EC] flex justify-center items-center gap-16 overflow-y-hidden">
      <div className="md:flex flex-col hidden">
        <div className="">
          <img
            src={`${BaseDirectories.LOGOS_DIR}/white.png`}
            alt="Arrow"
            className=""
          />
        </div>
        <div className="">
          <img
            src={`${BaseDirectories.IMAGES_DIR}/SignupLogin/signupside.png`}
            alt="Arrow"
            className=""
          />
        </div>
        <div className="text-white gap-6 flex flex-col mb-10">
          <h1 className="text-3xl font-bold mt-6">Building the Future...</h1>
          <p className="max-w-96">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.{' '}
          </p>
        </div>
        <div className="">
          <img
            src={`${BaseDirectories.IMAGES_DIR}/SignupLogin/carousel.png`}
            alt="Arrow"
            className=""
          />
        </div>
      </div>
      <div className="bg-white rounded-2xl md:mt-60 my-4 h-screen md:w-[30rem] w-[90%]">
        <div>
          <div className="text-start mx-12 pt-8">
            <span className="font-semibold">WELCOME BACK</span>
            <p className="text-2xl">Log In to your Account</p>
          </div>
          <form className="max-w-screen-lg mx-12 space-y-2 mt-8">
            <fieldset className="border-2 border-gray-300 rounded-lg p-2">
              <legend className="px-2 text-sm text-gray-700">Email</legend>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-lg focus:outline-none"
                placeholder="Enter your email"
                required
              />
            </fieldset>

            <fieldset className="border-2 border-gray-300 rounded-lg p-2 relative">
              <legend className="px-2 text-sm text-gray-700">Password</legend>
              <input
                type={showPassword ? 'text' : 'password'} 
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full rounded-lg focus:outline-none"
                placeholder="Enter your password"
                required
              />
              {/* Toggle Password Visibility Button */}
              <button
                type="button"
                onClick={togglePasswordVisibility}
                className="absolute top-auto  right-4 text-sm text-BrandCerulean font-bold focus:outline-none"
              >
                {showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
              </button>
            </fieldset>
           
            <div className="flex justify-between items-center mb-4">
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                <span className="ml-2 text-gray-600">Remember me</span>
              </label>
              <Link to="/forgot-password" className="text-BrandCerulean">
                Forgot password?
              </Link>
            </div>
          
            <Button
              type="submit"
              content="CONTINUE"
              route="/signup"
              className="w-full py-3 bg-BrandCerulean text-white font-bold rounded-md hover:bg-opacity-90 focus:ring-4 focus:ring-BrandCerulean focus:ring-opacity-50"
            />
          </form>
          <div className="text-center mt-2">
            <div className="flex items-center justify-center mt-2">
              <hr className="flex-grow border-t border-gray-300" />
              <span className="mx-4 text-gray-500">OR</span>
              <hr className="flex-grow border-t border-gray-300" />
            </div>
            <div className="flex flex-col gap-4 mt-4 mx-12 justify-center items-center">
              <button className="flex border text-[616161] items-center justify-center gap-10 w-full p-2 rounded-lg">
                <img
                  src={`${BaseDirectories.LOGOS_DIR}/google.png`}
                  alt="google"
                  className=""
                />
                <span>Log in with Google</span>
              </button>
              <button className="flex border text-[616161] items-center justify-center gap-10 w-full p-2  rounded-lg">
                <img
                  src={`${BaseDirectories.LOGOS_DIR}/facebook.png`}
                  alt="google"
                  className=""
                />
                <span> Log in with Facebook</span>
              </button>
              <button className="flex border text-[616161] items-center justify-center gap-10 w-full p-2 rounded-lg">
                <img
                  src={`${BaseDirectories.LOGOS_DIR}/apple.png`}
                  alt="google"
                  className=""
                />
                <span>Log in with Apple </span>
              </button>
            </div>
          </div>

          <div className="text-center mt-16 flex justify-center">
            <p className="text-gray-600 mr-2">New User? </p>
            <Link
              to="/signup"
              className="text-BrandCerulean font-bold underline"
            >
              SIGN UP HERE
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserLogin;
